import { QuizQuestionSortDto } from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';

export const QUIZ_QUESTIONS_PAGE_SIZE = 100;
export const QUIZ_QUESTIONS_SEARCH_DEBOUNCE_MS = 300;

// Dropdown value meaning "no filter" / "no segment window"
export const ALL_BOOKS = '';
export const SEGMENT_SIZE_ALL = 'all';

export const QUIZ_QUESTIONS_SORT_OPTIONS = [
  { name: 'Newest first', value: QuizQuestionSortDto.DESC },
  { name: 'Oldest first', value: QuizQuestionSortDto.ASC },
];
